const ExternalLink = ({ fillColor = "#5300C9", width = "17", height = "17" }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.63029 5.1665H4.29696C3.94333 5.1665 3.6042 5.30698 3.35415 5.55703C3.1041 5.80708 2.96362 6.14622 2.96362 6.49984V12.4998C2.96362 12.8535 3.1041 13.1926 3.35415 13.4426C3.6042 13.6927 3.94333 13.8332 4.29696 13.8332H10.297C10.6506 13.8332 10.9897 13.6927 11.2398 13.4426C11.4898 13.1926 11.6303 12.8535 11.6303 12.4998V9.1665M6.96362 9.83317L13.6303 3.1665M13.6303 3.1665H10.297M13.6303 3.1665V6.49984"
				stroke={fillColor}
				stroke-width="1.25"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};

export default ExternalLink;
